import React from 'react'

const normalizeUploadsBaseUrl = (value) => String(value || '').replace(/\/+$/, '');

export const normalizeAvatarUrl = (raw) => {
    const value = String(raw || '').trim();
    if (!value) return '';
    if (/^https?:\/\//i.test(value) || value.startsWith('blob:') || value.startsWith('data:')) return value;
    const cleaned = value.replace(/^\/+/, '');
    const uploadsBaseUrl = normalizeUploadsBaseUrl(process.env.REACT_APP_UPLOADS_API_BASE_URL);
    return uploadsBaseUrl ? `${uploadsBaseUrl}/${cleaned}` : cleaned;
};

// صورة مستخدم تُجلب بالتوكن (ملفات uploads محمية)، مع حرف أول الاسم كبديل عند غياب الصورة أو فشلها.
const AuthAvatar = ({ src, alt, style, size, fontSize = 10 }) => {
    const [previewSrc, setPreviewSrc] = React.useState('');
    const [failed, setFailed] = React.useState(false);
    const resolvedSrc = normalizeAvatarUrl(src);

    React.useEffect(() => {
        setPreviewSrc('');
        setFailed(false);
        if (!resolvedSrc) return undefined;
        if (resolvedSrc.startsWith('blob:') || resolvedSrc.startsWith('data:') || !/^https?:\/\//i.test(resolvedSrc)) {
            setPreviewSrc(resolvedSrc);
            return undefined;
        }

        const token = localStorage.getItem('token');
        const headers = token ? { Authorization: `Bearer ${token}` } : {};
        const controller = new AbortController();
        let objectUrl = '';

        fetch(resolvedSrc, { headers, signal: controller.signal })
            .then((res) => (res.ok ? res.blob() : null))
            .then((blob) => {
                if (!blob) {
                    setPreviewSrc(resolvedSrc);
                    return;
                }
                objectUrl = URL.createObjectURL(blob);
                setPreviewSrc(objectUrl);
            })
            .catch(() => setPreviewSrc(resolvedSrc));

        return () => {
            controller.abort();
            if (objectUrl) URL.revokeObjectURL(objectUrl);
        };
    }, [resolvedSrc]);

    const baseStyle = {
        borderRadius: '50%',
        objectFit: 'cover',
        flexShrink: 0,
        ...(size ? { width: size, height: size } : {}),
        ...style
    };
    const initial = String(alt || '?').trim().charAt(0).toUpperCase() || '?';

    if (!previewSrc || failed) {
        return (
            <span
                title={alt}
                style={{
                    ...baseStyle,
                    background: '#e2e8f0',
                    color: '#475569',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize,
                    fontWeight: 800
                }}
            >
                {initial}
            </span>
        );
    }
    return (
        <img
            src={previewSrc}
            alt={alt}
            title={alt}
            style={baseStyle}
            onError={() => setFailed(true)}
        />
    );
};

export default AuthAvatar
